import React, { forwardRef } from 'react';

import { FormFieldInterface } from './types';

const Textarea = forwardRef(({ register, ...rest }: FormFieldInterface, ref: (arg0: HTMLTextAreaElement) => HTMLTextAreaElement) => <textarea {...rest} {...register} ref={ref} />);

Textarea.displayName = 'Textarea';

export default Textarea;
